import { useDispatch, useSelector } from 'react-redux';
import { updateModalOpen } from '../slice/fileViewerSlice';
import useConf from './useConf';
import { useGetConfigurationQuery } from '../services/applicationApi';
import { getSearchFormValue, openContent } from '../utils/entityUtils';

export const useFileViewer = (viewName) => {
  const dispatch = useDispatch();
  const { getValue: conf } = useConf(useGetConfigurationQuery);
  const fileViewerConf = { ...conf('fileViewer'), ...conf(`${viewName}.fileViewer`, null) };
  const searchState = useSelector((state) => state.search);

  const displayFile = (file) => {
    if (conf('fileViewer', null) != null) {
      handleFileViewerMode(file);
    } else {
      openContent(file.contentId);
    }
  };

  function getFileViewerSearchQuery(viewName) {
    switch (viewName) {
      case 'search':
        return getSearchFormValue('content');
      case 'globalSearch':
        return searchState.globalSearchQuery;
      default:
        return '';
    }
  }

  function handleFileViewerMode(file) {
    localStorage.setItem('fileViewerFile', JSON.stringify(file));
    localStorage.setItem('fileViewerConf', JSON.stringify(fileViewerConf));
    localStorage.setItem('fileViewerSearchQuery', getFileViewerSearchQuery(viewName));
    if (fileViewerConf?.mode === 'tab') {
      handleFileViewerTabMode(file.hash);
    } else {
      handleFileViewerModalMode();
    }
  }

  function handleFileViewerTabMode(hash) {
    // open the file viewer in a new tab
    openFileViewerTab(hash);
  }

  function openFileViewerTab(hash) {
    const newWindow = window.open(
      `#/standalone/viewer/fileviewer/${hash}`,
      '_blank',
      'noopener,noreferrer'
    );
    if (newWindow) newWindow.opener = null;
  }

  function handleFileViewerModalMode() {
    // open the file viewer in modal
    dispatch(updateModalOpen(true));
  }

  return { displayFile };
};
